import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { CiGrid41 } from "react-icons/ci";
import { FaRegPaperPlane, FaRegUser } from "react-icons/fa";
import { HiOutlineUsers } from "react-icons/hi2";
import { IoCopyOutline, IoHelpCircleOutline, IoNavigateOutline, IoSendOutline } from "react-icons/io5";
import { CiCalendar } from "react-icons/ci";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { BsChatText } from "react-icons/bs";
import {
  FaSignOutAlt,
} from "react-icons/fa";
import { notification, Flex, Spin } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import "./sidebar.css";
import { logout } from '../../../controllers/investor/accounts'
import { sentFaqEmail } from "../../../controllers/common";
import { FRONT_BASE_URL } from "../../../config/constants";
import InvitePopup from "../InvitePopup";
const Sidebar = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const USERDATA = JSON.parse(sessionStorage.getItem('USER-INFO'));
  const [showHelp, setShowHelp] = useState(false);
  const toggaleShowHelp = () => setShowHelp(!showHelp);

  const [showInvite, setShowInvite] = useState(false);
  const toggleShowInvite = () => setShowInvite(!showInvite);

  
  // const [invitationLink, setInvitationLink] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  // const [formData, setFormData] = useState('');
  const [formData, setFormData] = useState({
    message: ''
  });
  const handleChange = (e) =>{
    try {
      const {name, value} = e.target;
      setFormData((pre)=>({
        ...pre,
        [name] : value
      }))
    } catch (error) {
      
    }
  }
  const handleLogout = async () => {
    await logout();
    navigate('/investor-login');
  }
  const handleFaqSubmit = async () => {
    try {
      setIsLoading(true);
      const {message} = formData;
      if(!message){
        notification.open({
          message: "Oops!",
          description: `Message is required`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      } else{
        const options = {
          email : `${USERDATA?.investor_email}`,
          name : `${USERDATA?.investor_first_name} ${USERDATA?.investor_last_name}`,
          message : message
        }
        const res = await sentFaqEmail(options);
        if(res.status === true){
          notification.open({
            message: "Your message has been sent!",
            description: `Expect a revert shortly.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          // setFormData(null);
          setFormData({
            message: ''
          });
          toggaleShowHelp();
        } else{
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
      setIsLoading(false);
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Please try after some time.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
  }

  
  return (
    <>
    <div
      className={`sidebar bg-dark text-light d-flex flex-column align-items-center sidebar_main_content  ${isSidebarOpen ? "visible" : "hidden" } ${USERDATA?.first_time_login?'blur':''}` } >
      <NavLink to="/investor/dashboard" className=" text-center text-decoration-none ">
        {({ isActive }) => (
          <div className="d-flex flex-column align-items-center  sidebar_mobileviews">
            <div
              className={` rounded side_bar_all_svg_logo ${
                isActive ? "" : "bg-secondary"
              }`}
              style={isActive ? { backgroundColor: "#a32532" } : {}}
            >
              <CiGrid41 className="text-light" size={24} />
            </div>
            <small className="side_bar_all_heading">Home</small>
          </div>
        )}
      </NavLink>

      <NavLink
        to="/investor/companies"
        className="text-center text-decoration-none "
      >
        {({ isActive }) => (
          <div className="d-flex flex-column align-items-center sidebar_mobileviews">
            <div
              className={` rounded side_bar_all_svg_logo ${
                isActive ? "" : "bg-secondary"
              }`}
              style={isActive ? { backgroundColor: "#a32532" } : {}}
            >
              
              <HiOutlineBuildingOffice2  className="text-light" size={24} />
            </div>
            <small className="side_bar_all_heading">Companies</small>
          </div>
        )}
      </NavLink>

      <NavLink
          to="/investor/interest"
          className=" text-center text-decoration-none "
        >
          {({ isActive }) => (
            <div className="d-flex flex-column align-items-center sidebar_mobileviews">
              <div
                className={` rounded side_bar_all_svg_logo ${
                  isActive ? "" : "bg-secondary"
                }`}
                style={isActive ? { backgroundColor: "#a32532" } : {}}
              >
               <HiOutlineUsers className="text-light" size={24} />
              </div>
              <small className="side_bar_all_heading">Interest</small>
            </div>
          )}
        </NavLink>

      <NavLink to="/investor/meetings" className=" text-center text-decoration-none ">
        {({ isActive }) => (
          <div className="d-flex flex-column align-items-center sidebar_mobileviews">
            <div
              className={` rounded side_bar_all_svg_logo ${
                isActive ? "" : "bg-secondary"
              }`}
              style={isActive ? { backgroundColor: "#a32532" } : {}}
            >
                <CiCalendar className="text-light" size={24} />
            </div>
            <small className="side_bar_all_heading">Meetings</small>
          </div>
        )}
      </NavLink>

      {/* <NavLink
        to="/investor/feedbacks"
        className=" text-center text-decoration-none "
      >
        {({ isActive }) => (
          <div className="d-flex flex-column align-items-center sidebar_mobileviews">
            <div
              className={`rounded side_bar_all_svg_logo ${
                isActive ? "" : "bg-secondary"
              }`}
              style={isActive ? { backgroundColor: "#a32532" } : {}}
            >
              <BsChatText  className="text-light" size={24} />
            </div>
            <small className="side_bar_all_heading">Feedbacks</small>
          </div>
        )}
      </NavLink> */}

      <NavLink
        to="javaScript:void(0)"
        onClick={toggleShowInvite}
        className=" text-center text-decoration-none "
      >
        {({ isActive }) => (
          <div className="d-flex flex-column align-items-center sidebar_mobileviews">
            <div
              className={` rounded side_bar_all_svg_logo ${
                isActive ? "" : "bg-secondary"
              }`}
              style={isActive ? { backgroundColor: "#a32532" } : {}}
            >
               <FaRegPaperPlane  className="text-light" size={24} />
            </div>
            <small className="side_bar_all_heading">Invite</small>
          </div>
        )}
      </NavLink>

      

      <NavLink
        to="javaScript:void(0)"
        onClick={toggaleShowHelp}
        className=" text-center text-decoration-none "
      >
        {({ isActive }) => (
          <div className="d-flex flex-column align-items-center sidebar_mobileviews">
            <div
              className={` rounded side_bar_all_svg_logo ${
                isActive ? "" : "bg-secondary"
              }`}
              style={isActive ? { backgroundColor: "#a32532" } : {}}
            >
               <IoHelpCircleOutline  className="text-light" size={24} />
            </div>
            <small className="side_bar_all_heading">Help</small>
          </div>
        )}
      </NavLink>

      <NavLink to="/investor/profile" className=" text-center text-decoration-none ">
        {({ isActive }) => (
          <div className="d-flex flex-column align-items-center sidebar_mobileviews">
            <div
              className={` rounded side_bar_all_svg_logo ${
                isActive ? "" : "bg-secondary"
              }`}
              style={isActive ? { backgroundColor: "#a32532" } : {}}
            >
              <FaRegUser className="text-light" size={20} />
            </div>
            <small className="side_bar_all_heading">Profile</small>
          </div>
        )}
      </NavLink>

      <NavLink to={false} className="text-center text-decoration-none " onClick={handleLogout}>
        {({ isActive }) => (
          <div className="d-flex flex-column align-items-center sidebar_mobileviews">
            <div
              className={` rounded side_bar_all_svg_logo bg-secondary`}
              style={isActive ? { backgroundColor: "#a32532" } : {}}
            >
              <FaSignOutAlt className="text-light" size={24} />
            </div>
            <small className="side_bar_all_heading">Logout</small>
          </div>
        )}
      </NavLink>
      </div>

      <div
        className="modal fade show"
        style={{ display: `${showHelp?'block':'none'}`, backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: "400px" }}
        >
          <div className="modal-content">
            <div className="modal-body text-center p-4 login_popup_modal">
              <h5 className="mb-4  scan_the_qr_code">
              How may I assist you?
              </h5>
              <form>
                <div className="row">
                  <div className="col-md-12 mb-12">
                    <input
                      type="text"
                      value="To : Chiratae Spotlight"
                      className="form-control all_input"
                      disabled
                    />
                  </div>
                </div>
                <br/>
                <div className="row">
                  <div className="col-md-12 mb-12">
                    <textarea 
                      name="message"
                      id="message"
                      value={formData?.message}
                      onChange={handleChange}
                      placeholder="Please write your message..."
                      className="form-control all_input"
                      rows={6}
                      >
                    </textarea>
                  </div>
                </div>
                <br/>
                <div className="profile_submit_btn">
                    <button type="button" 
                    onClick={handleFaqSubmit} 
                    >Submit</button>
                </div>
              </form>
            </div>
            <div className="position-absolute user_login_top_right_cross_btn">
              <button className="top-0 end-0 m-3" onClick={toggaleShowHelp}> x </button>
            </div>
          </div>
        </div>
        <Flex align="center" gap="middle">
          <Spin 
              size="large" 
              spinning={isLoading}
              fullscreen={true}
          />
        </Flex>
      </div>
      <InvitePopup showInvite={showInvite} toggleShowInvite={toggleShowInvite} />
    </>
  );
}

export default Sidebar;
